import { createEventBus } from "@bloglovin/vue-component-library/animation";

// Re-exports the VCL animation-engine bus factory and installs the legacy
// process-wide bus (fallback for trees without a page-scope provider).
export { createEventBus };

if (typeof window !== "undefined") {
  window.eventBus = createEventBus();
}
